import { render, staticRenderFns } from "./chadgpt.vue?vue&type=template&id=4b9a5516&scoped=true"
import script from "./chadgpt.vue?vue&type=script&lang=js"
export * from "./chadgpt.vue?vue&type=script&lang=js"
import style0 from "./chadgpt.vue?vue&type=style&index=0&id=4b9a5516&prod&scoped=true&lang=css"
import style1 from "./chadgpt.vue?vue&type=style&index=1&id=4b9a5516&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a5516",
  null
  
)

export default component.exports